export type DesignType = 'new' | 'old';
